import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#4a0e8f', light: '#6d35b5', dark: '#2d0860' },
    secondary: { main: '#c9a84c', light: '#e0c068', dark: '#a07830' },
    background: { default: '#fdfbf7', paper: '#ffffff' },
    text: { primary: '#1a0533', secondary: '#6b5a7e' },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: '"Nunito", sans-serif',
    h1: { fontFamily: '"Cormorant Garamond", serif', fontWeight: 700 },
    h2: { fontFamily: '"Cormorant Garamond", serif', fontWeight: 700 },
    h3: { fontFamily: '"Cormorant Garamond", serif', fontWeight: 700 },
    h4: { fontFamily: '"Cormorant Garamond", serif', fontWeight: 700 },
    button: { fontFamily: '"Nunito", sans-serif', textTransform: 'none', fontWeight: 800 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          backgroundColor: '#fdfbf7',
          color: '#1a0533',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          padding: '11px 22px',
        },
        containedPrimary: {
          color: '#ffffff',
          backgroundImage: 'linear-gradient(135deg, #e0c068 0%, #c9a84c 48%, #a07830 100%)',
          boxShadow: '0 10px 24px rgba(201,168,76,0.28)',
          '&:hover': {
            backgroundImage: 'linear-gradient(135deg, #e7c977 0%, #d1b35a 48%, #ac7e2e 100%)',
            boxShadow: '0 12px 26px rgba(201,168,76,0.34)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 32px rgba(201,168,76,0.25)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          transition: 'background-color 0.3s ease, backdrop-filter 0.3s ease',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1a0533',
          color: '#ffffff',
        },
      },
    },
  },
});

export default theme;
